import * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import * as transformers from '@attain-apps/transformers'

import * as dimensionFilter from '../dimension-filter'

// Aliases both the type and its namespace, so the fully qualified entity path
// doesn't have to be repeated in every transformer below
import Configuration = ents.extra.space.Report.Configuration.UnassignedSponsoredPeople

export const FILTER_INPUT = graphql.transformers.IN.object<
  Configuration.Filter,
  graphql.schema.SpacePayrollsFilterInput
>({
  organizationFilter: dimensionFilter.TRANSFORMER,
})

export const CONFIGURATION_INPUT = graphql.transformers.IN.object<
  Configuration,
  graphql.schema.SpaceReportUnassignedSponsoredPeopleConfigurationInput
>({
  filter: graphql.transformers.IN.nonNull(FILTER_INPUT),
  showSalaryInformation: transformers.PASS_THROUGH,
})
